import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { AuthLayout } from "./Login";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { useTr } from "@/i18n/translator";
import PasswordInput from "@/components/PasswordInput";

export default function ResetPassword() {
  const tr = useTr();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password !== confirm) {
      setErr("Las contraseñas no coinciden");
      return;
    }
    if (!token) {
      setErr("Token faltante en la URL");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(tr("Contraseña actualizada. Inicia sesión."));
      nav("/login");
    } catch (ex) {
      setErr(formatApiError(ex.response?.data?.detail) || ex.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title={tr("Nueva contraseña")} subtitle="RESTABLECER ACCESO">
      <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
        <label className="block">
          <span className="font-mono-mark text-[10px] text-[#5C5C5C]">{tr("NUEVA CONTRASEÑA (MÍN 6)")}</span>
          <div className="mt-2">
            <PasswordInput
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength={6}
              testid="reset-password"
            />
          </div>
        </label>
        <label className="block">
          <span className="font-mono-mark text-[10px] text-[#5C5C5C]">CONFIRMAR</span>
          <div className="mt-2">
            <PasswordInput
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              minLength={6}
              testid="reset-confirm"
            />
          </div>
        </label>
        {err && (
          <div className="border border-[#E53935] bg-[#E53935]/10 px-4 py-3 font-mono-data text-sm text-[#E53935]" data-testid="reset-error">
            {err}
          </div>
        )}
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-[#E53935] text-white px-4 py-3 font-mono-mark text-xs hover-brutal border border-[#E53935] flex items-center justify-center gap-2 disabled:opacity-50"
          data-testid="reset-submit"
        >
          {loading ? "ACTUALIZANDO…" : "ACTUALIZAR CONTRASEÑA"}
          {!loading && <ArrowRight className="w-4 h-4" />}
        </button>
        <div className="text-center font-mono-data text-sm">
          <Link to="/login" className="underline decoration-[#E53935] underline-offset-4">Cancelar</Link>
        </div>
      </form>
    </AuthLayout>
  );
}
